var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16659 19.25L5.58325 16.5833L2.58325 15.9167L2.87492 12.8333L0.833252 10.5L2.87492 8.16667L2.58325 5.08333L5.58325 4.41667L7.16659 1.75L9.99992 2.95833L12.8333 1.75L14.4166 4.41667L17.4166 5.08333L17.1249 8.16667L19.1666 10.5L17.1249 12.8333L17.4166 15.9167L14.4166 16.5833L12.8333 19.25L9.99992 18.0417L7.16659 19.25ZM9.12492 13.4583L13.8333 8.75L12.6666 7.54167L9.12492 11.0833L7.33325 9.33333L6.16659 10.5L9.12492 13.4583Z",
    fill: "#323EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.302ae4a7e2e264f5a636b3e4d9a5e519.svg";
export { ForwardRef as ReactComponent };